import { render, staticRenderFns } from "./MedisOptions.vue?vue&type=template&id=1833ed36&"
import script from "./MedisOptions.vue?vue&type=script&lang=ts&"
export * from "./MedisOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports